import { uniqBy } from 'lodash';
import { SituacaoAprovacao } from 'px-business-components';

export function isUserAprovadorProduto(user, niveis) {
  if (!user || !niveis || !niveis.length) {
    return false;
  }

  const { criaHierarquia } = niveis[0];
  const niveisPendentes = niveis
    .filter(nivel => nivel.situacao === SituacaoAprovacao.keys.PENDENTE.key);

  if (!niveisPendentes.length) {
    return false;
  }

  // Se criaHierarquia for true, considera apenas o primeiro/próximo nível pendente
  // Se criaHierarquia for false, considera todos os níveis pendentes
  const niveisConsiderados = criaHierarquia ? [niveisPendentes[0]] : niveisPendentes;

  const aprovadores = niveisConsiderados.flatMap(nivel => nivel.aprovadores)
    .filter(aprovador => aprovador.situacao === SituacaoAprovacao.keys.PENDENTE.key)
    .map(aprovacao => aprovacao.gestor);
  const aprovadoresUnicos = uniqBy(aprovadores, 'id');
  return aprovadoresUnicos.some(aprovador => aprovador.id === user.id);
}

export function isUserAprovadorSolicitacao(user, aprovacao) {
  if (!user || !aprovacao) {
    return false;
  }
  const { produtos } = aprovacao;
  return produtos.some(produto => isUserAprovadorProduto(user, produto.niveis));
}

export function getProdutosPendentesPorAprovador(user, aprovacao) {
  if (!user || !aprovacao) {
    return [];
  }
  return aprovacao.produtos
    .filter(aprovador => aprovador.situacao === SituacaoAprovacao.keys.PENDENTE.key)
    .filter(produto => isUserAprovadorProduto(user, produto.niveis));
}

/**
 * Retorna a situação de aprovação do usuário
 * A situação do usuário pode ser diferente da situação principal do item de aprovação
 * Exemplo: o item de aprovação pode estar aprovado para o usuário, mas ainda aguardando
 * outras aprovações
 * @param user
 * @param niveis
 */
export function situacaoAprovacaoItemUser(user, itemAprovacao) {
  if (!user || !itemAprovacao.niveis || !itemAprovacao.niveis.length) {
    return itemAprovacao.situacao;
  }

  // se o item já estiver finalizado, não sobrescreve a situação com base no usuário
  const isItemFinalizado = [
    SituacaoAprovacao.keys.RECUSADO.key,
    SituacaoAprovacao.keys.APROVADO.key,
  ].includes(itemAprovacao.situacao);

  if (isItemFinalizado) {
    return itemAprovacao.situacao;
  }

  // busca a aprovação do usuário
  const aprovacaoUser = itemAprovacao.niveis
    .flatMap(nivel => nivel.aprovadores)
    .find(aprovador => aprovador.gestor.id === user.id);

  if (!aprovacaoUser) {
    return itemAprovacao.situacao;
  }

  return aprovacaoUser.situacao;
}

/**
 * Retorna a situação de aprovação do usuário para uma solicitação/compra
 * A situação do usuário pode ser diferente da situação principal da compra
 * Exemplo: a compra pode estar aprovada para o usuário, mas ainda aguardando
 * outras aprovações
 * @param user
 * @param aprovacao
 * @returns {string|*}
 */
export function situacaoAprovacaoUser(user, aprovacao) {
  if (!user || !aprovacao) {
    return aprovacao.situacao;
  }

  const situacoes = aprovacao.produtos.map(produto => situacaoAprovacaoItemUser(user, produto));
  if (situacoes.includes(SituacaoAprovacao.keys.PENDENTE.key)) {
    return SituacaoAprovacao.keys.PENDENTE.key;
  }
  if (situacoes.includes(SituacaoAprovacao.keys.RECUSADO.key)) {
    return SituacaoAprovacao.keys.RECUSADO.key;
  }
  return SituacaoAprovacao.keys.APROVADO.key;
}
